import { API } from '@/api';
import { fetcher, HTTPError } from '@/services/fetcher';

import { type CreateContractApi, contractApiSchema } from '../../models';
import { logger } from '../../utils/logger';

const pricing = fetcher.extend(() => ({ prefixUrl: `${API.BASE_PRICING}` }));

export const createContract = async (
  payload: CreateContractApi,
  { signal }: { signal?: AbortController['signal'] } = {},
) => {
  try {
    return await pricing.post('contract', { json: payload, signal }).json(contractApiSchema);
  } catch (error) {
    if (error instanceof HTTPError) {
      logger.error(`Error: ${error.response.status}`);
    }
    throw error;
  }
};
